import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFlag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"flag-1, priority"} maskId="square-filled-radius-0-stroke-1-IconFlag1"><path d="M4 2V22H5V16H21.3948L17.0871 9L21.3948 2H4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFlag1;
